import React, { useState, useEffect } from "react";
import axios from "axios";
import AdminNavbar from "./AdminNavbar";
import "./AdminUpdates.css";

function AdminUpdates() {
  const [heading, setHeading] = useState("");
  const [media, setMedia] = useState([]);
  const [updates, setUpdates] = useState([]);
  const [currentUpdateId, setCurrentUpdateId] = useState(null);
  const [loadedMedia, setLoadedMedia] = useState({}); // Track loaded state

  const fetchUpdates = async () => {
    try {
      const res = await axios.get("https://himchatterjee.in/backend/get_updates.php");
      setUpdates(res.data.reverse());
      setLoadedMedia({}); // reset loader tracking
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchUpdates();
  }, []);

  const handleHeadingUpload = async (e) => {
    e.preventDefault();
    if (!heading.trim()) {
      alert("Please enter a heading");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("heading", heading);

      const res = await axios.post(
        "https://himchatterjee.in/backend/upload_update.php",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data.status === "success") {
        alert(res.data.message);
        setCurrentUpdateId(res.data.update_id);

        setUpdates((prev) => [
          {
            id: res.data.update_id,
            heading: heading,
            media: [],
          },
          ...prev,
        ]);

        setHeading("");
      } else {
        alert("Failed to create heading");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleMediaUpload = async (e) => {
    e.preventDefault();

    if (!currentUpdateId) {
      alert("Please create/select a heading first");
      return;
    }

    if (media.length === 0) {
      alert("Please select at least one file.");
      return;
    }

    const formData = new FormData();
    formData.append("update_id", currentUpdateId);
    for (let i = 0; i < media.length; i++) {
      formData.append("media[]", media[i]);
    }

    try {
      const res = await axios.post(
        "https://himchatterjee.in/backend/upload_media.php",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      alert(res.data.message);
      setMedia([]);
      fetchUpdates();
    } catch (err) {
      console.error(err);
      alert("Upload failed!");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this update?")) return;
    try {
      await axios.post("https://himchatterjee.in/backend/delete_update.php", { id });
      fetchUpdates();
    } catch (err) {
      console.error(err);
      alert("Delete failed!");
    }
  };

  // Media loaded callback
  const handleMediaLoad = (id) => {
    setLoadedMedia((prev) => ({ ...prev, [id]: true }));
  };

  return (
    <>
      <AdminNavbar />

      <div style={{ maxWidth: "700px", margin: "0 auto", padding: "20px" }}>
        <h2>Admin - Add Latest Update</h2>

        {/* Step 1: Add Heading */}
        <form onSubmit={handleHeadingUpload}>
          <input
            type="text"
            placeholder="Enter heading"
            value={heading}
            onChange={(e) => setHeading(e.target.value)}
            style={{ display: "block", width: "100%", marginBottom: "10px", padding: "8px" }}
          />
          <button type="submit" style={{ padding: "10px 20px", cursor: "pointer" }}>
            Create Heading
          </button>
        </form>

        {/* Step 2: Add Media */}
        {currentUpdateId && (
          <form onSubmit={handleMediaUpload} style={{ marginTop: "20px" }}>
            <input
              type="file"
              accept="image/*,video/*"
              multiple
              onChange={(e) => setMedia(e.target.files)}
              style={{ display: "block", marginBottom: "10px" }}
            />
            <button type="submit" style={{ padding: "10px 20px", cursor: "pointer" }}>
              Upload Media to Current Heading
            </button>
          </form>
        )}

        <hr style={{ margin: "20px 0" }} />

        <h3>Uploaded Updates</h3>
        {updates.length === 0 ? (
          <p>No updates yet.</p>
        ) : (
          updates.map((u) => (
            <div
              key={u.id}
              style={{
                marginBottom: "20px",
                border: "1px solid #ddd",
                padding: "10px",
                borderRadius: "8px",
              }}
            >
              <h4>{u.heading}</h4>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                {u.media.map((m) => (
                  <div
                    key={m.id}
                    style={{ position: "relative", width: "150px", height: "150px" }}
                  >
                    {!loadedMedia[m.id] && <div className="media-loader"></div>}

                    {m.file_type === "image" ? (
                      <img
                        src={m.file_path}
                        alt=""
                        style={{
                          width: "150px",
                          borderRadius: "6px",
                          display: loadedMedia[m.id] ? "block" : "none",
                        }}
                        onLoad={() => handleMediaLoad(m.id)}
                      />
                    ) : (
                      <video
                        controls
                        style={{
                          width: "150px",
                          borderRadius: "6px",
                          display: loadedMedia[m.id] ? "block" : "none",
                        }}
                        onLoadedData={() => handleMediaLoad(m.id)}
                      >
                        <source src={m.file_path} type="video/mp4" />
                      </video>
                    )}
                  </div>
                ))}
              </div>
              <button
                onClick={() => handleDelete(u.id)}
                style={{
                  marginTop: "10px",
                  padding: "6px 12px",
                  cursor: "pointer",
                  background: "red",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                }}
              >
                Delete
              </button>
            </div>
          ))
        )}
      </div>
    </>
  );
}

export default AdminUpdates;
